import { connect } from 'react-redux';

// action creators
import { openQuitFlowModal } from 'current/uiwidgets';

// selectors
import { isInitialLoadDone } from 'api/loading/selectors';
import { getActiveScriptType } from 'current/selectors';
import { getAllMessages } from 'messages/selectors';
import { isAppMode } from 'settings/selectors';

import Create from './Create';

export default connect(
  (state) => {
    return {
      activeScriptType: getActiveScriptType(state),
      initialLoadIsInProgress: !isInitialLoadDone(state),
      isAppMode: isAppMode(state),
      messages: getAllMessages(state)
    };
  },
  (dispatch) => {
    return {
      onClickCancel: () => {
        dispatch(openQuitFlowModal());
      }
    };
  }
)(Create);
